var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraNotEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447716 0.447715 0 1 0H15.9958C16.5481 0 16.9958 0.447715 16.9958 1V3.99876C16.9958 4.55105 17.4435 4.99876 17.9958 4.99876H18.4601C18.7945 4.99876 19.1067 4.83166 19.2922 4.55346L20.9948 1.9995H21.9945V14.4001C21.9945 14.7294 21.7276 14.9963 21.3984 14.9963C21.1546 14.9963 20.9354 14.8479 20.8449 14.6215L19.2467 10.6261C19.0949 10.2465 18.7272 9.99752 18.3183 9.99752H17.9958C17.4435 9.99752 16.9958 10.4452 16.9958 10.9975V13.9963C16.9958 14.5486 16.5481 14.9963 15.9958 14.9963H1C0.447715 14.9963 0 14.5486 0 13.9963V1Z",
    fill: "#626365"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.496,
    y: 9.50293,
    width: 12.997,
    height: 12.997,
    rx: 1.5,
    fill: "#D44441",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 13.1748L24.8224 18.8303",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 18.8311L24.8224 13.1756",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraNotEnabled);
export default __webpack_public_path__ + "static/media/camera-not-enabled.0bb6424cfe08d50b700051f90a710a8b.svg";
export { ForwardRef as ReactComponent };